import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import SearchBarContainer from '../../../components/SearchBar/SearchBarContainer';
import { FETCH_BUY_NOW_OFFERS, FETCH_OFFERS } from '../../../redux/Offers';
import { SET_COUNTRIES } from '../../../redux/Table';
import Select from '../../Select/Select';
import { compose } from 'redux';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';
class BreadcrumbsOffer extends React.Component {
  render() {
    const { newOffersCount,
      onSearchClick,
      tableName,
      isMobile,
      fetchOffers,
      setCountries,
      availabeCountries,
      selectedCountries,
      t, } = this.props;

      if (newOffersCount) {
        this.newOffersLabel = (
        <div className="main-area__badge main-area__badge--header">
          {`${newOffersCount} ${t('new_offers')}`}
        </div>)
      }

      this.handleChange = (arg) => {
        setCountries({ countries: arg, });
        fetchOffers();
      };
  return (
    <div className="main-area__header main-area__header-with_badge">
      { isMobile &&
        <div>
          <SearchBarContainer onSearchClick={onSearchClick} tableName={tableName} delay={600} /> <br/>
          <div style={{ display: 'flex', alignItems: 'center', marginRight: '2em', }}>
          <Select
            value={selectedCountries}
            onChange={(arg) => this.handleChange(arg)}
            options={availabeCountries?.map((item) => ({ value: item, label: (t(item.toUpperCase()) ? t(item.toUpperCase()) : item.toUpperCase()), }))}
            isMulti
            isMobile={isMobile}
            placeholder={t('chose_country')}
          />
          </div>
        </div>
      }

      <div className="details__menu">
        <ul>
        <span>{t(tableName)}</span>
        {this.newOffersLabel}
        </ul>
      </div>

     {!isMobile &&
        <div style={{ display: 'flex', alignItems: 'center', marginRight: '2em', marginLeft: 'auto', }}>
            <Select
              value={selectedCountries}
              onChange={(arg) => this.handleChange(arg)}
              options={availabeCountries?.map((item) => ({ value: item, label: (t(item.toUpperCase()) ? t(item.toUpperCase()) : item.toUpperCase()), }))}
              isMulti
              isMobile={isMobile}
              placeholder={t('chose_country')}
            />
      </div>
    }

    { !isMobile && <SearchBarContainer onSearchClick={onSearchClick} tableName={tableName} delay={600} />

    }
      <style jsx="true">{`
        .main-area__header {
          display: flex;
          justify-content: space-between;
        }
      `}</style>
    </div>
  );
  }
}

BreadcrumbsOffer.propTypes = {
  t: PropTypes.func.isRequired,
  tableName: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  fetchOffers: PropTypes.func.isRequired,
  setCountries: PropTypes.func.isRequired,
  selectedCountries: PropTypes.arrayOf(PropTypes.object),
  availabeCountries: PropTypes.arrayOf(PropTypes.string),
  onSearchClick: PropTypes.func,
  newOffersCount: PropTypes.number,
};

BreadcrumbsOffer.defaultProps = {
  onSearchClick: null,
  newOffersCount: null,
  selectedCountries: [],
  availabeCountries: [],
  isMobile: true,
};


const mapDispatchToProps = (dispatch, { tableName, }) => {
  const fetchAction = tableName === 'buy_now' ? FETCH_BUY_NOW_OFFERS : FETCH_OFFERS;
  return {
    fetchOffers: () => dispatch(fetchAction()),
    setCountries: (payload) => dispatch(SET_COUNTRIES({ ...payload, tableName, })),
  };
};

const mapStateToProps = (state, { tableName, }) => {
  return {
    isMobile: get(state, ['layout', 'isMobile']),
    newOffersCount: get(state, ['offers', 'new_offers_count']),
    availabeCountries: get(state, ['offers', 'available_countries']),
    selectedCountries: get(state, ['tables', tableName, 'countries']),
  };
};

export default compose(
  withScopedTranslations('breadcrumbs.browse'),
  connect(mapStateToProps, mapDispatchToProps)
)(BreadcrumbsOffer);
